import { render, staticRenderFns } from "./storePolicy.vue?vue&type=template&id=3578b60f&scoped=true"
import script from "./storePolicy.vue?vue&type=script&lang=js"
export * from "./storePolicy.vue?vue&type=script&lang=js"
import style0 from "./storePolicy.vue?vue&type=style&index=0&id=3578b60f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3578b60f",
  null
  
)

export default component.exports